import { useMutation } from '@tanstack/react-query'
import { useNavigate } from '@tanstack/react-router'
import { resetPassword } from '../utils/resetPassword'
import type { ApiError } from '@/types/api'
import { toast } from '@/integrations/toaster-provider'
import { notifyRequestError } from '@/utils/notifyRequestError'

type ResetPasswordMutationVariables = {
  token: string
  newPassword: string
}

export const useResetPasswordMutation = () => {
  const navigate = useNavigate()

  return useMutation({
    mutationFn: ({ token, newPassword }: ResetPasswordMutationVariables) => {
      if (!token) {
        throw new Error('Token not provided')
      }
      return resetPassword({
        token,
        newPassword,
      })
    },
    onSuccess: () => {
      toast.success('Password reset successfully')
      navigate({ to: '/login' })
    },
    onError: (error: ApiError) => {
      notifyRequestError(error, 'Failed to reset password')
    },
  })
}
